import React, { useEffect, useState } from "react";
import { Amplify, API, graphqlOperation } from "aws-amplify";
import { Container, Row, Col, ListGroup, ListGroupItem } from "reactstrap";
import { Link } from "react-router-dom";
import "../../styles/footer.css";
import logo from "../../assets/all-images/winson-stone-logo.jpeg";
import { listProductCategories, getAddress } from "../../graphql/queries";
import { getAddressDetailsInfo } from "../../commonFunction";
import axios from "axios";

const listProductCategoryLinks = [{}];
const listAddressLinks = [{}];


const socialLinks = [
  {
    url: "https://www.instagram.com/WINSONSTONE.US/",
    icon: "ri-instagram-line",
  },
  {
    url: "https://api.whatsapp.com/send/?phone=%2B16462918929&text&type=phone_number&app_absent=0",
    icon: "ri-facebook-line",
  },

  {
    url: "https://api.whatsapp.com/send/?phone=%2B16462918929&text&type=phone_number&app_absent=0",
    icon: "ri-whatsapp-line",
  },
  {
    url: "https://www.youtube.com/channel/UCrgRhzKX8Bn7XadqwnAWyWA",
    icon: "ri-youtube-line",
  },
];

const Footer = (props) => {
  const date = new Date();
  const year = date.getFullYear();
 

  const [listProductCat, setlistProductCat] = useState(
    listProductCategoryLinks
  );
  const [listAddressDetails, setAddressDetails] = useState(listAddressLinks);

  useEffect(() => {
    // (async () => {
    fetchTodos();
    // })
  }, []);
  const fetchTodos = async () => {
    try {
      const listProductCatData = await API.graphql(
        graphqlOperation(listProductCategories)
      );
      const _productCategoriesList =
        listProductCatData?.data?.listProductCategories?.items;
      setlistProductCat(_productCategoriesList);
        //fetching address details
      const addressDetails = await getAddressDetailsInfo("address");
console.log(addressDetails, "addressDetails")
      setAddressDetails(addressDetails);
    } catch (err) {
      console.log(err, "error addressDetails");
    }
  };

  return (
    <footer className="footer">
      <Container>
        <Row>
         
          <Col lg="3" md="3" sm="12">
            <div className="logo footer__logo">
            <h5 className="footer__link-title">Follow Us</h5>
              {/* <h3 className="logo_section">
                <Link to="/home" className="d-flex align-items-center gap-2">
                  <img
                    src={logo}
                    className="rounded"
                    height="100%"
                    width="220px"
                    alt="logo"
                  />
                </Link>
              </h3> */}
            </div>
             
              <div className=" d-flex align-items-center gap-4 mt-3">
                {socialLinks.map((item, index) => (
                  <Link to={item.url} key={index} target="_blank" className="social__link-icon">
                    <i class={item.icon}></i>
                  </Link>
                ))}
              </div>

            <p className="footer__logo-content"></p>
          </Col>
          <Col lg="3" md="3" sm="6">
            <div className="mb-2">
              <h5 className="footer__link-title">Products</h5>
              <ListGroup>
                {listProductCat.map((categoryList, index) => (
                  <ListGroupItem key={index} className="p-0 mt-2 quick__link">
                    {/* <Link to={`/product-category/${categoryList.navigateTo}`}>
                      {categoryList.title}
                    </Link> */}
                     <a href={`/product-category/${categoryList.navigateTo}`}>
                      {categoryList.title}
                    </a>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </div>
          </Col>
          <Col lg="3" md="3" sm="6">
            <h5 className="footer__link-title">Head office</h5>

            
            <p className="office__info">{listAddressDetails.address},</p>
            <p className="office__info">{listAddressDetails.zipCode},</p>
            <p className="office__info">{listAddressDetails.state},</p>
            <p className="office__info">{listAddressDetails.country}.</p>
          
          </Col>
          <Col lg="3" md="3" sm="4">
            <div className="">
              <h5 className="footer__link-title">Contact</h5>
              <p className="office__info">{listAddressDetails.companyName}</p>
            <p className="office__info">{listAddressDetails.email}</p>
            <p className="office__info">{listAddressDetails.mobileNumber}</p>
            
            </div>
          </Col>

          <Col lg="12">
            <div className="footer__bottom">
              <p className="section__description d-flex align-items-center justify-content-center gap-1 pt-4">
                <i className="ri-copyright-line"></i>Copyright {year}, Developed
                by Winson Stone. All rights reserved.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
